import { Component, EventEmitter, OnInit, Output, TemplateRef } from '@angular/core';
import { GlobalInfo, UsuarioActual } from '@app/shared';

import { AuthenticationService } from '../../authentication/authentication.service';
import { GlobalInfoService } from '../../utilities/global-info.service';
import { I18nService } from '../../utilities/i18n.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';

@Component({
  selector: 'iw-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Output() clickedIconBar = new EventEmitter<Boolean>();
  toggleIconBar = false;

  globalInfo: Partial<GlobalInfo>;
  // Referencia de la modal
  modalRef: BsModalRef;

  constructor(
    private as: AuthenticationService,
    private i18nService: I18nService,
    private gis: GlobalInfoService,
    private modalService: BsModalService
  ) { }

  ngOnInit() {
    // se obtiene la informacion global
    this.gis.get().subscribe(data => {
      this.globalInfo = data;
    });
  }

  toggle() {
    this.toggleIconBar = !this.toggleIconBar;
    this.clickedIconBar.emit(this.toggleIconBar);
  }

  /**
   * Cambia el lenguaje de la aplicación.
   *
   * @param {string} language
   * @memberof HeaderComponent
   */
  setLanguage(language: string) {
    this.i18nService.language = language;
  }

  /**
   * Cierra la sesión del usuario.
   *
   * @memberof HeaderComponent
   */
  logout() {
    this.as.logout();
    location.reload();
  }

  /**
   * Obtiene el lenguaje actual de la aplicación.
   *
   * @readonly
   * @type {string}
   * @memberof HeaderComponent
   */
  get currentLanguage(): string {
    return this.i18nService.language;
  }

  /**
   * Obtiene todos los lenguajes de la aplicación.
   *
   * @readonly
   * @type {string[]}
   * @memberof HeaderComponent
   */
  get languages(): string[] {
    return this.i18nService.supportedLanguages;
  }

  /**
   * Retorna las credenciales del usuario autenticado.
   *
   * @readonly
   * @type {UsuarioActual}
   * @memberof HeaderComponent
   */
  get user(): UsuarioActual {
    return this.as.getCredentials();
  }

  /**
   * Abre una modal con una template especificada
   *
   * @param {TemplateRef<any>} template
   * @memberof HeaderComponent
   */
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  /**
   * Cerrar modal dinamica
   *
   * @memberof HeaderComponent
   */
  closeModal() {
    this.modalRef.content = null;
    this.modalRef.hide();
  }

}



// WEBPACK FOOTER //
// ./src/app/core/shell/header/header.component.ts